import { color_white } from "../../../constants/colors";
import { useI18n } from "../../../i18n/I18nProvider";

const SEARCH_ICON_DATA_URI =
  "url(\"data:image/svg+xml;utf8,<svg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M6.875 11.875C9.63642 11.875 11.875 9.63642 11.875 6.875C11.875 4.11358 9.63642 1.875 6.875 1.875C4.11358 1.875 1.875 4.11358 1.875 6.875C1.875 9.63642 4.11358 11.875 6.875 11.875Z' stroke='%23B1B1B1' stroke-linecap='round' stroke-linejoin='round'/><path d='M13.125 13.125L10.4062 10.4062' stroke='%23B1B1B1' stroke-linecap='round' stroke-linejoin='round'/></svg>\")";

const SearchBar = ({ searchValue, setSearchValue }) => {
    const { t } = useI18n();

    return (
        <div style={{
            position: "relative",
            marginBottom: 20,
            width: "100%",
        }}>
            <input
                style={{
                    height: 45,
                    width: "100%",
                    maxWidth: "100%",
                    boxSizing: "border-box",
                    backgroundColor: color_white, 
                    borderRadius: 10,
                    paddingLeft: 40,
                    fontFamily: "Onest",
                    fontSize: 16,
                    outline: "none",
                    border: "none",
                    backgroundImage: SEARCH_ICON_DATA_URI,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "15px center",
                }}
                placeholder={t("Введите запрос...")} value={searchValue} onChange={(event) => setSearchValue(event.target.value)}
            />
        </div>
    )
}

export default SearchBar;
